import { render, staticRenderFns } from "./Newspaper.vue?vue&type=template&id=645d9714&"
import script from "./Newspaper.vue?vue&type=script&lang=js&"
export * from "./Newspaper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports